export default {
    auditTab: {
        actionCreated: 'Ustvarjeno',
        actionAmended: 'Spremenjeno',
        actionStatus: 'Status',
        secondsAgo: 'pred {n}s',
        minutesAgo: 'pred {n}m',
        hoursAgo: 'pred {n}h',
        daysAgo: 'pred {n}d',
        loadingHistory: 'Nalaganje zgodovine revizije…',
        loadFailed: 'Nalaganje zgodovine revizije ni uspelo.',
        empty: 'Za to pogodbo še ni zgodovine revizije.',
        headerWhen: 'Kdaj',
        headerAction: 'Dejanje',
        headerStatusChange: 'Sprememba statusa',
        headerActor: 'Izvajalec',
        headerDetails: 'Podrobnosti',
        showDiff: 'Prikaži razlike',
        hideDiff: 'Skrij razlike',
        before: 'Prej',
        after: 'Potem',
    },
}
